import { render, staticRenderFns } from "./StatsPanel.vue?vue&type=template&id=2cbd5de8&scoped=true&"
import script from "./StatsPanel.vue?vue&type=script&lang=js&"
export * from "./StatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatsPanel.vue?vue&type=style&index=0&id=2cbd5de8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd5de8",
  null
  
)

export default component.exports